var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg911Testmode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 16,
    fill: "#FF6B35"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 21.25L16.45 19.1C16.2667 18.9167 16.0333 18.825 15.75 18.825C15.4667 18.825 15.2333 18.9167 15.05 19.1C14.8667 19.2833 14.775 19.5167 14.775 19.8C14.775 20.0833 14.8667 20.3167 15.05 20.5L17.9 23.35C18.1 23.55 18.3333 23.65 18.6 23.65C18.8667 23.65 19.1 23.55 19.3 23.35L24.95 17.7C25.1333 17.5167 25.225 17.2833 25.225 17C25.225 16.7167 25.1333 16.4833 24.95 16.3C24.7667 16.1167 24.5333 16.025 24.25 16.025C23.9667 16.025 23.7333 16.1167 23.55 16.3L18.6 21.25ZM13 29C12.45 29 11.9792 28.8042 11.5875 28.4125C11.1958 28.0208 11 27.55 11 27V13C11 12.45 11.1958 11.9792 11.5875 11.5875C11.9792 11.1958 12.45 11 13 11H17.2C17.4167 10.4 17.7792 9.91667 18.2875 9.55C18.7958 9.18333 19.3667 9 20 9C20.6333 9 21.2042 9.18333 21.7125 9.55C22.2208 9.91667 22.5833 10.4 22.8 11H27C27.55 11 28.0208 11.1958 28.4125 11.5875C28.8042 11.9792 29 12.45 29 13V27C29 27.55 28.8042 28.0208 28.4125 28.4125C28.0208 28.8042 27.55 29 27 29H13ZM20 12.25C20.2167 12.25 20.3958 12.1792 20.5375 12.0375C20.6792 11.8958 20.75 11.7167 20.75 11.5C20.75 11.2833 20.6792 11.1042 20.5375 10.9625C20.3958 10.8208 20.2167 10.75 20 10.75C19.7833 10.75 19.6042 10.8208 19.4625 10.9625C19.3208 11.1042 19.25 11.2833 19.25 11.5C19.25 11.7167 19.3208 11.8958 19.4625 12.0375C19.6042 12.1792 19.7833 12.25 20 12.25Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg911Testmode);
export default __webpack_public_path__ + "static/media/911_testmode.706bb11c497e9446c8f0ffee286add63.svg";
export { ForwardRef as ReactComponent };